var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "settlement bj" },
    [
      _c("div", { staticClass: "title" }, [
        _c(
          "div",
          { staticClass: "seach order-wrapper" },
          [
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入供货单编号", clearable: "" },
                  model: {
                    value: _vm.from1.supplier_order_no,
                    callback: function ($$v) {
                      _vm.$set(_vm.from1, "supplier_order_no", $$v)
                    },
                    expression: "from1.supplier_order_no",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", placeholder: "请选择集配中心" },
                    model: {
                      value: _vm.from1.logistic_business_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.from1, "logistic_business_id", $$v)
                      },
                      expression: "from1.logistic_business_id",
                    },
                  },
                  _vm._l(_vm.logisticsList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择供货商",
                    },
                    model: {
                      value: _vm.from1.supplier_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.from1, "supplier_id", $$v)
                      },
                      expression: "from1.supplier_id",
                    },
                  },
                  _vm._l(_vm.supplierList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.title, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "times" },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "daterange",
                    "range-separator": "至",
                    "value-format": "yyyy-MM-dd",
                    "start-placeholder": "创建开始日期",
                    "end-placeholder": "创建结束日期",
                  },
                  on: { change: _vm.createChange },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "times" },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "daterange",
                    "range-separator": "至",
                    "value-format": "yyyy-MM-dd",
                    "start-placeholder": "结算开始日期",
                    "end-placeholder": "结算结束日期",
                  },
                  on: { change: _vm.countChange },
                  model: {
                    value: _vm.value1,
                    callback: function ($$v) {
                      _vm.value1 = $$v
                    },
                    expression: "value1",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", placeholder: "请选择状态" },
                    model: {
                      value: _vm.from1.liquidation_status,
                      callback: function ($$v) {
                        _vm.$set(_vm.from1, "liquidation_status", $$v)
                      },
                      expression: "from1.liquidation_status",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "全部结算状态", value: "" },
                    }),
                    _c("el-option", { attrs: { label: "已结算", value: "1" } }),
                    _c("el-option", { attrs: { label: "未结算", value: "2" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入流水号", clearable: "" },
                  model: {
                    value: _vm.from1.liquidation_no,
                    callback: function ($$v) {
                      _vm.$set(_vm.from1, "liquidation_no", $$v)
                    },
                    expression: "from1.liquidation_no",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inputs" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", placeholder: "请选择复核状态" },
                    model: {
                      value: _vm.from1.qc_status,
                      callback: function ($$v) {
                        _vm.$set(_vm.from1, "qc_status", $$v)
                      },
                      expression: "from1.qc_status",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "全部复核状态", value: "" },
                    }),
                    _c("el-option", {
                      attrs: { label: "未复核", value: "10" },
                    }),
                    _c("el-option", {
                      attrs: { label: "已复核", value: "40" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-button", {
              staticClass: "bjsearch",
              attrs: { type: "primary", icon: "el-icon-refresh" },
              on: { click: _vm.Refresh },
            }),
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.search },
              },
              [_vm._v("查询")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  disabled: !_vm.tableData.length || _vm.disabledExport,
                  type: "warning",
                  icon: "el-icon-download",
                },
                on: { click: _vm.onHandleExport },
              },
              [_vm._v("导出列表")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  disabled: !_vm.tableData.length || _vm.disabledDetailsExport,
                  type: "warning",
                  icon: "el-icon-download",
                },
                on: { click: _vm.onHandleExportDetails },
              },
              [_vm._v("导出明细")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_no",
                  align: "center",
                  label: "流水号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplier_order_no",
                  align: "center",
                  label: "供货单编号",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$empty.empty(scope.row.supplier_order_no)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistic_business_name",
                  align: "center",
                  label: "集配中心",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$empty.empty(scope.row.logistic_business_name)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "供货商名称" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.supplier
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$empty.empty(scope.row.supplier.title)
                                  ) +
                                  " "
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  align: "center",
                  label: "创建时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.create_time)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "product_amount",
                  align: "center",
                  label: "供货单金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$empty.empty(
                                _vm.tool.format_money(scope.row.product_amount)
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "qc_amount",
                  align: "center",
                  label: "复核缺货金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.qc_amount || "-") + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "qc_status_txt",
                  align: "center",
                  label: "复核状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.qc_status_txt || "-") + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_time_pre",
                  align: "center",
                  label: "预结算时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.liquidation_time_pre || "-") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_status",
                  align: "center",
                  label: "结算状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$empty.empty(
                                scope.row.liquidation_status == 1
                                  ? "已结算"
                                  : "未结算"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_time",
                  align: "center",
                  label: "结算日期",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$empty.time(scope.row.liquidation_time)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "service_fee_amount",
                  label: _vm.serviceFeeLabel,
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "charges_fee",
                  align: "center",
                  label: "采销服务费",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.charges_fee || "-") + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "promotion_charges_fee_real",
                  align: "center",
                  label: "推广奖励",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.promotion_charges_fee_real || "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_amount_pre",
                  align: "center",
                  label: "预结算金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.liquidation_amount_pre || "-") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_status_pre_txt",
                  align: "center",
                  label: "预结算状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.liquidation_status_pre_txt || "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "liquidation_amount",
                  align: "center",
                  label: "结算金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$empty.empty(
                                _vm.tool.format_money(
                                  scope.row.liquidation_amount
                                )
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": 10,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: _vm.title,
                visible: _vm.centerDialogVisible,
                width: "500px",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "业务模块",
                            prop: "business_type_code",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "选择业务模块",
                                  },
                                  model: {
                                    value: _vm.ruleForm.business_type_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "business_type_code",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.business_type_code",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "业务名称", prop: "itemdata" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "选择业务名称",
                                  },
                                  on: { change: _vm.changestore },
                                  model: {
                                    value: _vm.ruleForm.itemdata,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "itemdata", $$v)
                                    },
                                    expression: "ruleForm.itemdata",
                                  },
                                },
                                _vm._l(_vm.options1, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.name,
                                      value: JSON.stringify(item),
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号", prop: "username" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入账号",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "username", $$v)
                                  },
                                  expression: "ruleForm.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "密码", prop: "password" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入密码",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "password", $$v)
                                  },
                                  expression: "ruleForm.password",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.tianku } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }